import { createAsyncThunk } from '@reduxjs/toolkit';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { BasketItem } from 'src/types';
import { selectPersonalisationFromBasket } from '../selectors';

export const updatePersonalisationOptionsFromBasketItem = createAsyncThunk<BasketItem | undefined>(
  'personalisation/updatePersonalisationOptionsFromBasketItem',
  async (_, { getState }) => {
    return selectPersonalisationFromBasket(getState() as ReduxApplicationState);
  },
);
